import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconArrowSvg } from "./IconArrowSvg.mjs";
import { root, mirror, flip, rotate } from "./IconArrow.css.mjs";
const IconArrow = ({ direction = "up", ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: ({ className, ...svgProps }) => /* @__PURE__ */ jsx(
  Box,
  {
    component: IconArrowSvg,
    className: [
      root,
      className,
      {
        [rotate]: direction === "right" || direction === "left",
        [flip]: direction === "down",
        [mirror]: direction === "left"
      }
    ],
    ...svgProps
  }
) });
export {
  IconArrow
};
